'use strict';
var React = require('react');
var FormatMessage = require('react-globalize').FormatMessage;

var SectionList = React.createClass({

      /**
       * @return {object}
       */
      render: function() {
        return <div>
              <FormatMessage locale={this.props.locale} path="compliancePage/customerDescription2" /><br/><br/>
              <div className="row">
                <div className="col-sm-8 col-xs-8">
                <ul><li><FormatMessage locale={this.props.locale} path="compliancePage/customerList1" /></li>
                   <li><FormatMessage locale={this.props.locale} path="compliancePage/customerList2" /></li>
                   <li><FormatMessage locale={this.props.locale} path="compliancePage/customerList3" /></li>
                </ul><br/><br/>
                </div>
              </div>
              <FormatMessage locale={this.props.locale} path="compliancePage/customerDescription3" /><br/><br/>
        </div>
      }
});

var BfgCompliance = React.createClass({

render: function() {
    var message = "";

    if (this.props.locale == 'en') {
      message =  <SectionList locale={this.props.locale} />;
    }
  return <section id="compliance" className="content-section text-center compliance-section">
    <div className="row">
    <div className="col-sm-2 col-xs-2"></div>
    <div className="col-sm-8 col-xs-8">

    <h3 className="text-center"><FormatMessage locale={this.props.locale} path="compliancePage/title" /></h3><hr className="small"/>
    <FormatMessage locale={this.props.locale} path="compliancePage/description1" /><br/><br/>
    <FormatMessage locale={this.props.locale} path="compliancePage/description2" /><br/><br/>


    <h4 className="compliance-bold"><FormatMessage locale={this.props.locale} path="compliancePage/information1" /></h4>

        <FormatMessage locale={this.props.locale} path="compliancePage/information2" /><br/><br/>
  <ul>
  <li><FormatMessage locale={this.props.locale} path="compliancePage/infoList1" /></li>
  <li><FormatMessage locale={this.props.locale} path="compliancePage/infoList2" /></li>
  <li><FormatMessage locale={this.props.locale} path="compliancePage/infoList3" /></li>
  </ul><br/>


  <h4 className="compliance-bold"><FormatMessage locale={this.props.locale} path="compliancePage/security" /></h4>
  <FormatMessage locale={this.props.locale} path="compliancePage/securityDescription" /><br/><br/>


  <h4 className="compliance-bold"><FormatMessage locale={this.props.locale} path="compliancePage/disclosure" /></h4>
    <p><FormatMessage locale={this.props.locale} path="compliancePage/disclosureDescription" /></p>

  <h4 className="compliance-bold"><FormatMessage locale={this.props.locale} path="compliancePage/customer" /></h4>

  <FormatMessage locale={this.props.locale} path="compliancePage/customerDescription1" /><br/><br/>
    {message}
  <h4 className="compliance-bold"><FormatMessage locale={this.props.locale} path="compliancePage/employeeResponsability" /></h4>
  <FormatMessage locale={this.props.locale} path="compliancePage/employeeDescription" />

  </div>
  <div className="col-sm-2 col-xs-2"></div>
    </div>
    </section>
}
})


module.exports = BfgCompliance



// WEBPACK FOOTER //
// ./js/compliance.js